/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompoundingReasonModel } from './CompoundingReasonModel';
import {
    CompoundingReasonModelFromJSON,
    CompoundingReasonModelFromJSONTyped,
    CompoundingReasonModelToJSON,
} from './CompoundingReasonModel';
import type { PetPrescriptionLastOrderModel } from './PetPrescriptionLastOrderModel';
import {
    PetPrescriptionLastOrderModelFromJSON,
    PetPrescriptionLastOrderModelFromJSONTyped,
    PetPrescriptionLastOrderModelToJSON,
} from './PetPrescriptionLastOrderModel';

/**
 * 
 * @export
 * @interface PetPrescriptionModel
 */
export interface PetPrescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    legacyId?: string;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    userName?: string;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    petId?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    petName?: string;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    vetId?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    oldVetId?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    vetName?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    clientId?: string;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    clinicId?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    oldClinicId?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    clinicName?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    clinicPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    partNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    partName?: string;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    itemId?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    itemParentId?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    itemType?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    gtin?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    fullImage?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    thumbnail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    isBundle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    isChewyFresh?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    type?: PetPrescriptionModelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    prescribedDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    createdById?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    updatedById?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    prescriptionExpirationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    updatedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    statusCode?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    durStatusCode?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    durModifierId?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    durAt?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    businessUnit?: PetPrescriptionModelBusinessUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    siteId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    isUnlimited?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    amountUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    refillAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    amountRemaining?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    quantityPrescribed?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    amountAllowed?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    itemPackageQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    itemUnitType?: PetPrescriptionModelItemUnitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    itemExpirationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    approvedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    approverId?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    deniedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    denierId?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    closedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionModel
     */
    closerId?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    changeStatusReason?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    directions?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    notes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    dispenseAsWritten?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    giveWithFood?: boolean;
    /**
     * 
     * @type {Array<CompoundingReasonModel>}
     * @memberof PetPrescriptionModel
     */
    compoundingReasons?: Array<CompoundingReasonModel>;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    compoundingReasonComment?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    compoundingAllergyComment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    compounded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    hasAttachment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    prescriptionLink?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    unverified?: boolean;
    /**
     * 
     * @type {PetPrescriptionLastOrderModel}
     * @memberof PetPrescriptionModel
     */
    lastOrder?: PetPrescriptionLastOrderModel;
    /**
     * 
     * @type {boolean}
     * @memberof PetPrescriptionModel
     */
    equivalentMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionModel
     */
    approvalChannel?: string;
}


/**
 * @export
 */
export const PetPrescriptionModelTypeEnum = {
    Rx: 'RX',
    Px: 'PX'
} as const;
export type PetPrescriptionModelTypeEnum = typeof PetPrescriptionModelTypeEnum[keyof typeof PetPrescriptionModelTypeEnum];

/**
 * @export
 */
export const PetPrescriptionModelBusinessUnitEnum = {
    B2C: 'B2C',
    B2B: 'B2B'
} as const;
export type PetPrescriptionModelBusinessUnitEnum = typeof PetPrescriptionModelBusinessUnitEnum[keyof typeof PetPrescriptionModelBusinessUnitEnum];

/**
 * @export
 */
export const PetPrescriptionModelItemUnitTypeEnum = {
    Gm: 'GM',
    Lbs: 'LBS',
    Ml: 'ML',
    Oz: 'OZ',
    Bags: 'BAGS',
    Bottles: 'BOTTLES',
    Boxes: 'BOXES',
    Cans: 'CANS',
    Caplets: 'CAPLETS',
    Capsules: 'CAPSULES',
    Inhaler: 'INHALER',
    Item: 'ITEM',
    Needles: 'NEEDLES',
    Pack: 'PACK',
    Pouches: 'POUCHES',
    Scoops: 'SCOOPS',
    Syringes: 'SYRINGES',
    Tablets: 'TABLETS',
    Tubes: 'TUBES',
    Vials: 'VIALS'
} as const;
export type PetPrescriptionModelItemUnitTypeEnum = typeof PetPrescriptionModelItemUnitTypeEnum[keyof typeof PetPrescriptionModelItemUnitTypeEnum];


/**
 * Check if a given object implements the PetPrescriptionModel interface.
 */
export function instanceOfPetPrescriptionModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetPrescriptionModelFromJSON(json: any): PetPrescriptionModel {
    return PetPrescriptionModelFromJSONTyped(json, false);
}

export function PetPrescriptionModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetPrescriptionModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'legacyId': !exists(json, 'legacyId') ? undefined : json['legacyId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'petId': !exists(json, 'petId') ? undefined : json['petId'],
        'petName': !exists(json, 'petName') ? undefined : json['petName'],
        'vetId': !exists(json, 'vetId') ? undefined : json['vetId'],
        'oldVetId': !exists(json, 'oldVetId') ? undefined : json['oldVetId'],
        'vetName': !exists(json, 'vetName') ? undefined : json['vetName'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'clinicId': !exists(json, 'clinicId') ? undefined : json['clinicId'],
        'oldClinicId': !exists(json, 'oldClinicId') ? undefined : json['oldClinicId'],
        'clinicName': !exists(json, 'clinicName') ? undefined : json['clinicName'],
        'clinicPhone': !exists(json, 'clinicPhone') ? undefined : json['clinicPhone'],
        'partNumber': !exists(json, 'partNumber') ? undefined : json['partNumber'],
        'partName': !exists(json, 'partName') ? undefined : json['partName'],
        'itemId': !exists(json, 'itemId') ? undefined : json['itemId'],
        'itemParentId': !exists(json, 'itemParentId') ? undefined : json['itemParentId'],
        'itemType': !exists(json, 'itemType') ? undefined : json['itemType'],
        'gtin': !exists(json, 'gtin') ? undefined : json['gtin'],
        'fullImage': !exists(json, 'fullImage') ? undefined : json['fullImage'],
        'thumbnail': !exists(json, 'thumbnail') ? undefined : json['thumbnail'],
        'isBundle': !exists(json, 'isBundle') ? undefined : json['isBundle'],
        'isChewyFresh': !exists(json, 'isChewyFresh') ? undefined : json['isChewyFresh'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'prescribedDate': !exists(json, 'prescribedDate') ? undefined : json['prescribedDate'],
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'updatedById': !exists(json, 'updatedById') ? undefined : json['updatedById'],
        'prescriptionExpirationDate': !exists(json, 'prescriptionExpirationDate') ? undefined : json['prescriptionExpirationDate'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'statusCode': !exists(json, 'statusCode') ? undefined : json['statusCode'],
        'durStatusCode': !exists(json, 'durStatusCode') ? undefined : json['durStatusCode'],
        'durModifierId': !exists(json, 'durModifierId') ? undefined : json['durModifierId'],
        'durAt': !exists(json, 'durAt') ? undefined : json['durAt'],
        'businessUnit': !exists(json, 'businessUnit') ? undefined : json['businessUnit'],
        'siteId': !exists(json, 'siteId') ? undefined : json['siteId'],
        'isUnlimited': !exists(json, 'isUnlimited') ? undefined : json['isUnlimited'],
        'amountUsed': !exists(json, 'amountUsed') ? undefined : json['amountUsed'],
        'refillAmount': !exists(json, 'refillAmount') ? undefined : json['refillAmount'],
        'amountRemaining': !exists(json, 'amountRemaining') ? undefined : json['amountRemaining'],
        'quantityPrescribed': !exists(json, 'quantityPrescribed') ? undefined : json['quantityPrescribed'],
        'amountAllowed': !exists(json, 'amountAllowed') ? undefined : json['amountAllowed'],
        'itemPackageQuantity': !exists(json, 'itemPackageQuantity') ? undefined : json['itemPackageQuantity'],
        'itemUnitType': !exists(json, 'itemUnitType') ? undefined : json['itemUnitType'],
        'itemExpirationDate': !exists(json, 'itemExpirationDate') ? undefined : json['itemExpirationDate'],
        'approvedAt': !exists(json, 'approvedAt') ? undefined : json['approvedAt'],
        'approverId': !exists(json, 'approverId') ? undefined : json['approverId'],
        'deniedAt': !exists(json, 'deniedAt') ? undefined : json['deniedAt'],
        'denierId': !exists(json, 'denierId') ? undefined : json['denierId'],
        'closedAt': !exists(json, 'closedAt') ? undefined : json['closedAt'],
        'closerId': !exists(json, 'closerId') ? undefined : json['closerId'],
        'changeStatusReason': !exists(json, 'changeStatusReason') ? undefined : json['changeStatusReason'],
        'directions': !exists(json, 'directions') ? undefined : json['directions'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'dispenseAsWritten': !exists(json, 'dispenseAsWritten') ? undefined : json['dispenseAsWritten'],
        'giveWithFood': !exists(json, 'giveWithFood') ? undefined : json['giveWithFood'],
        'compoundingReasons': !exists(json, 'compoundingReasons') ? undefined : ((json['compoundingReasons'] as Array<any>).map(CompoundingReasonModelFromJSON)),
        'compoundingReasonComment': !exists(json, 'compoundingReasonComment') ? undefined : json['compoundingReasonComment'],
        'compoundingAllergyComment': !exists(json, 'compoundingAllergyComment') ? undefined : json['compoundingAllergyComment'],
        'compounded': !exists(json, 'compounded') ? undefined : json['compounded'],
        'hasAttachment': !exists(json, 'hasAttachment') ? undefined : json['hasAttachment'],
        'prescriptionLink': !exists(json, 'prescriptionLink') ? undefined : json['prescriptionLink'],
        'unverified': !exists(json, 'unverified') ? undefined : json['unverified'],
        'lastOrder': !exists(json, 'lastOrder') ? undefined : PetPrescriptionLastOrderModelFromJSON(json['lastOrder']),
        'equivalentMatch': !exists(json, 'equivalentMatch') ? undefined : json['equivalentMatch'],
        'approvalChannel': !exists(json, 'approvalChannel') ? undefined : json['approvalChannel'],
    };
}

export function PetPrescriptionModelToJSON(value?: PetPrescriptionModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'legacyId': value.legacyId,
        'userId': value.userId,
        'userName': value.userName,
        'petId': value.petId,
        'petName': value.petName,
        'vetId': value.vetId,
        'oldVetId': value.oldVetId,
        'vetName': value.vetName,
        'clientId': value.clientId,
        'clinicId': value.clinicId,
        'oldClinicId': value.oldClinicId,
        'clinicName': value.clinicName,
        'clinicPhone': value.clinicPhone,
        'partNumber': value.partNumber,
        'partName': value.partName,
        'itemId': value.itemId,
        'itemParentId': value.itemParentId,
        'itemType': value.itemType,
        'gtin': value.gtin,
        'fullImage': value.fullImage,
        'thumbnail': value.thumbnail,
        'isBundle': value.isBundle,
        'isChewyFresh': value.isChewyFresh,
        'type': value.type,
        'prescribedDate': value.prescribedDate,
        'createdById': value.createdById,
        'updatedById': value.updatedById,
        'prescriptionExpirationDate': value.prescriptionExpirationDate,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'statusCode': value.statusCode,
        'durStatusCode': value.durStatusCode,
        'durModifierId': value.durModifierId,
        'durAt': value.durAt,
        'businessUnit': value.businessUnit,
        'siteId': value.siteId,
        'isUnlimited': value.isUnlimited,
        'amountUsed': value.amountUsed,
        'refillAmount': value.refillAmount,
        'amountRemaining': value.amountRemaining,
        'quantityPrescribed': value.quantityPrescribed,
        'amountAllowed': value.amountAllowed,
        'itemPackageQuantity': value.itemPackageQuantity,
        'itemUnitType': value.itemUnitType,
        'itemExpirationDate': value.itemExpirationDate,
        'approvedAt': value.approvedAt,
        'approverId': value.approverId,
        'deniedAt': value.deniedAt,
        'denierId': value.denierId,
        'closedAt': value.closedAt,
        'closerId': value.closerId,
        'changeStatusReason': value.changeStatusReason,
        'directions': value.directions,
        'notes': value.notes,
        'dispenseAsWritten': value.dispenseAsWritten,
        'giveWithFood': value.giveWithFood,
        'compoundingReasons': value.compoundingReasons === undefined ? undefined : ((value.compoundingReasons as Array<any>).map(CompoundingReasonModelToJSON)),
        'compoundingReasonComment': value.compoundingReasonComment,
        'compoundingAllergyComment': value.compoundingAllergyComment,
        'compounded': value.compounded,
        'hasAttachment': value.hasAttachment,
        'prescriptionLink': value.prescriptionLink,
        'unverified': value.unverified,
        'lastOrder': PetPrescriptionLastOrderModelToJSON(value.lastOrder),
        'equivalentMatch': value.equivalentMatch,
        'approvalChannel': value.approvalChannel,
    };
}

